// extracted by mini-css-extract-plugin
export default {"thumbnailIcon":"styles_thumbnailIcon__ul8OA","thumbnailIconfile":"styles_thumbnailIconfile__QKexP","bigIcon":"styles_bigIcon__+h6aW","bigIconImage":"styles_bigIconImage__66-FA"};